module.exports = __webpack_public_path__ + "img/gdgy.b17fef65.png";